import React from "react";
import Script from "next/script";

const PLUG_CLIENT_DOMAIN =
  process.env.NEXT_PUBLIC_ASSET_HOST ?? "assets.bwbx.io";

const PLUG_SCRIPT_SRC = `//${PLUG_CLIENT_DOMAIN}/s3/fence/plug-client/v0/app.bundle.js`;

export function initPlug() {
  return () => {
    if (typeof window !== "undefined" && window.plugClient) {
      const config = {
        "top-of-content": `.plug-top-of-content`,
        banner: `.plug-banner`,
      };

      window.plugClient.init(config);
    }
  };
}

export function PlugScript() {
  return (
    <Script
      src={PLUG_SCRIPT_SRC}
      id="plug-client-snippet"
      onReady={initPlug()}
      strategy="lazyOnload"
    />
  );
}
